import { render } from "./SpeakCoursewareCard.vue?vue&type=template&id=34d1e48a&scoped=true"
import script from "./SpeakCoursewareCard.vue?vue&type=script&lang=ts"
export * from "./SpeakCoursewareCard.vue?vue&type=script&lang=ts"

import "./SpeakCoursewareCard.vue?vue&type=style&index=0&id=34d1e48a&scoped=true&lang=css"
import "./SpeakCoursewareCard.vue?vue&type=style&index=1&id=34d1e48a&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-34d1e48a"

export default script